import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import "./BlockchainGaming.css";
import Footer from "./Footer";
import tokenomicsShellStyle from "../styles/tokenomicsShellStyle";
import SeoHead from "../components/SeoHead";
import ComingSoonButton from "../components/ComingSoonButton";

function BlockchainGaming() {
  return (
    <div className="tokenomics-shell" style={tokenomicsShellStyle}>
      <SeoHead
        title="Atheriam Blockchain - Fast, Secure Layer 1 for Web3"
        description="Build on Atheriam - a fast, secure, and scalable Layer 1 blockchain for developers, traders, and businesses with ultra-low fees and next-gen security."
        path="/blockchain"
      />
      <Header />
      <main className="blockchain-main">
        <section className="block_hero">
          <div className="container-fluid container-md">
            <div className="block_main">
              <div className="">
                <h1 className="block_head">ATHERIAM</h1>
                <p className="block_head_tagline">AI · Gaming · Blockchain</p>
                <div className="w_100 text-end" />
              </div>
              <div className="block_main_subhead">
                <span className="block_subhead_title">
                  A fast, secure, and scalable Layer 1 for developers, traders,
                  and businesses. Build advanced dApps, trade digital assets with
                  ultra-low fees, and drive innovation with seamless efficiency,
                  interoperability, and next-gen security.
                </span>
                <div className="block_subhead_btnman">
                  <ComingSoonButton
                    title="Start Building"
                    className="blockhero_start_buld"
                  >
                    <span>Start Building</span>
                  </ComingSoonButton>
                  <ComingSoonButton
                    title="Start Building"
                    className="blockhero_start_buld"
                    aria-label="Start Building"
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </ComingSoonButton>
                </div>
              </div>
            </div>
            <div className="block_gif_main">
              <img
                src={require("../assets/blockchainAssets/hero-gif-new-two.gif")}
                alt="heroGif"
              />
            </div>
          </div>
        </section>
        <section className="next_gen_main">
          <div className="container">
            <div className="next_gen_main_imp">
              <div className="nxt_top_man">
                <div className="nxt_top_featdiv">
                  <span>Features</span>
                </div>
                <h2 className="nxt_top_had">
                  Next-Gen Blockchain. Unmatched Performance.
                </h2>
              </div>
              <div className="nxt_top_subman">
                <div className="row mx-0 g-4">
                  <div className="col-xl-8 col-lg-6">
                    <div className="nxt_inn_box">
                      <div className="row mx-0">
                        <div className="col-xl-5 d-flex justify-content-center">
                          <img
                            src={require("../assets/blockchainAssets/next-first.webp")}
                            alt="NextGen"
                            className="next_frst_img"
                          />
                        </div>
                        <div className="col-xl-7 d-flex align-items-center">
                          <div className="next_frst_right">
                            <h2>Smart & Secure Contracts</h2>
                            <span>
                              Automate and execute with efficiency, reliability,
                              and complete transparency. Build powerful dApps
                              with secure, self-executing agreements.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6">
                    <div className="nxt_inn_box_4">
                      <h2>1M+ TPS</h2>
                      <div className="next_2_bot">
                        <h3>Unstoppable Speed</h3>
                        <span>
                          Lightning-fast transactions with unmatched
                          scalability.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mx-0 g-4 justify-content-center">
                  <div className="col-xl-4 col-lg-6">
                    <div className="nxt_inn_box_4">
                      <h2>$0.001 Fees</h2>
                      <div className="next_2_bot">
                        <h3>Ultra-Low Fees</h3>
                        <span>
                          Near-zero costs for seamless and affordable
                          transactions.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6">
                    <div className="nxt_inn_box_4">
                      <h2> 50+</h2>
                      <div className="next_2_bot">
                        <h3>Integrated Chains</h3>
                        <span>
                          Connect across 50+ blockchains for seamless
                          interoperability.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6">
                    <div className="next_last_box">
                      <img
                        src={require("../assets/blockchainAssets/next-last.webp")}
                        alt="NextGen"
                      />
                      <div className="next_last_box_bootm">
                        <span className="">Blockchain for Gaming</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="super_whole">
          <div className="super_chan">
            <div className="super_chan_main">
              <div className="super_main_mel">
                <div className="super_main_mel_beni">
                  <span>Benefits</span>
                </div>
                <h2>Supercharge Your Blockchain Experience</h2>
              </div>
              <span className="super_main_dwn">
                Unlock the full potential of blockchain with speed, security,
                and efficiency.
              </span>
            </div>
          </div>
          <div className="super_wht">
            <div className="container">
              <div className="row">
                <div className="col-xl-6">
                  <div className="super_wht_left">
                    <div className="wht_lft_top">
                      <h2>Experience Unstoppable Speed and Seamless Scaling</h2>
                      <span>
                        Atheriam is built to handle millions of transactions
                        with zero congestion ensuring smooth and instant
                        processing for trading decentralized apps blockchain
                        gaming and digital asset transfers providing a
                        frictionless experience with unmatched speed security
                        and scalability for users and developers across the
                        ecosystem
                      </span>
                    </div>
                    <Link to="/whitepaper" className="what_bton">
                      <span>Explore Atheriam</span>
                      <i className="fa-solid fa-arrow-right mt-1"></i>
                    </Link>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="sup_wht_righ">
                    <img
                      src={require("../assets/blockchainAssets/super-white-s.gif")}
                      alt="SuperCharge"
                    />
                  </div>
                </div>
              </div>
              <div className="row supr_wht_botmar g-3 justify-content-center">
                <div className="col-xl-4 col-lg-6">
                  <div className="supr_chn_botbox">
                    <h3>Next Level Security</h3>
                    <span>
                      Advanced encryption and decentralized validation safeguard
                      every transaction and asset
                    </span>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6">
                  <div className="supr_chn_botbox">
                    <h3>Efficient & Affordable</h3>
                    <span>
                      Save more and transact faster with ultra-low fees and
                      seamless performance
                    </span>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6">
                  <div className="supr_chn_botbox">
                    <h3>Boundless Connectivity</h3>
                    <span>
                      Seamlessly interact across multiple blockchains for
                      limitless possibilities
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="super_chan">
            <div className="super_chan_main second">
              <div className="super_main_mel">
                <div className="super_main_mel_beni">
                  <span>How It Works</span>
                </div>
                <h2> Redefining Blockchain Power</h2>
              </div>
              <span className="super_main_dwn second">
                Experience seamless transactions unmatched security and
                limitless scalability for every blockchain need
              </span>
            </div>
          </div>
          <div className="super_blck">
            <div className="container">
              <div className="row mx-0 supblck_main">
                <div className="col-lg-6">
                  <div className="supblck_main_lftt">
                    <img
                      src={require("../assets/blockchainAssets/super-black-unscreen.gif")}
                      alt="SuperCharge"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="super_wht_left">
                    <div className="wht_lft_top_blck">
                      <h2>Experience Unstoppable Speed and Seamless Scaling</h2>
                      <span>
                        Atheriam is built to handle millions of transactions
                        with zero congestion ensuring smooth and instant
                        processing for trading decentralized apps blockchain
                        gaming and digital asset transfers providing a
                        frictionless experience with unmatched speed security
                        and scalability for users and developers across the
                        ecosystem
                      </span>
                    </div>
                    <Link to="/tokenomics" className="what_bton">
                      <span>Explore Tokenomics</span>
                      <i className="fa-solid fa-arrow-right mt-1"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row supr_blck_botmar g-4 justify-content-center">
                <div className="col-xl-4 col-lg-6">
                  <div className="supblck_inn_box">
                    <img
                      src={require("../assets/blockchainAssets/super-blackin-frst.webp")}
                      alt="SuperCharge"
                    />
                    <div className="supblck_inn_box_btm">
                      <h4>Instant Transactions</h4>
                      <span>
                        Advanced encryption and decentralized validation keep
                        every transaction and asset fully protected
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6">
                  <div className="supblck_inn_box">
                    <img
                      src={require("../assets/blockchainAssets/super-blackin-scnd.webp")}
                      alt="SuperCharge"
                    />
                    <div className="supblck_inn_box_btm">
                      <h4> Next-Gen Security</h4>
                      <span>
                        Advanced encryption and decentralized validation keep
                        every transaction and asset fully protected
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6">
                  <div className="supblck_inn_thirdbox">
                    <div className="supblck_inn_thirdbox_blr">
                      <span>Unleash the Full Power of Atheriam</span>
                      <ComingSoonButton
                        title="Start Building"
                        className="thirdblr_inn_btn"
                      >
                        <span>Start Building</span>
                        <i className="fa-solid fa-arrow-right mt-1"></i>
                      </ComingSoonButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="super_last">
          <div className="super_last_main">
            <div className="super_last_main_top">
              <h2>Be Part of the Future with Atheriam</h2>
              <span>
                Join a next-gen blockchain built for speed security and
                limitless innovation Whether you're a developer trader or
                investor Atheriam empowers you to scale and succeed
              </span>
            </div>
            <div className="super_last_main_bot">
              <Link to="/whitepaper" className="super_last_botlef">
                <span>Read Whitepaper</span>
                <i className="fa-solid fa-arrow-right mt-1"></i>
              </Link>
              <Link to="/ico" className="super_last_botrigh">
                <span>Join the ICO</span>
                <i className="fa-solid fa-arrow-right mt-1"></i>
              </Link>
            </div>
          </div>
          <div className="super_lastpos_abslef">
            <img
              src={require("../assets/blockchainAssets/super-last-new.gif")}
              alt="SuperCharge"
            />
          </div>
          <div className="super_lastpos_absrigh">
            <img
              src={require("../assets/blockchainAssets/super-last-new.gif")}
              alt="SuperCharge"
            />
          </div>
        </div>
        <Footer />
      </main>
    </div>
  );
}

export default BlockchainGaming;
